export function personaToAudiences(persona) {
    switch (persona) {
        case 'super_admin':
        case 'admin':
            // Admins see admin docs AND agent docs (they manage agents) AND
            // generic. They do NOT see customer/vendor docs by default —
            // those are role-specific surfaces.
            return ['All', 'Admin', 'Agent'];
        case 'agent':
            return ['All', 'Agent'];
        case 'customer':
            return ['All', 'Customer'];
        case 'vendor':
            return ['All', 'Vendor'];
    }
}
export function audienceMatches(articleAudiences, viewerPersona) {
    const allowed = new Set(personaToAudiences(viewerPersona));
    return articleAudiences.some((a) => allowed.has(a));
}
/**
 * Whether an article's optional feature-flag gate is satisfied for this viewer.
 * No gate → always true (unchanged behaviour). A gate → true only when the
 * tenant has that flag on. Reuses the `feature_flags` already on `me`; never
 * exposes content, only hides a guide for a feature the tenant lacks.
 */
export function featureFlagSatisfied(article, featureFlags) {
    if (!article.featureFlag)
        return true;
    return !!featureFlags?.[article.featureFlag];
}
/**
 * The single visibility predicate for an article = audience match AND feature
 * flag satisfied. Used by HelpHome (list filter) and Article (deep-link guard)
 * so both stay in lockstep.
 */
export function articleVisible(article, viewerPersona, featureFlags) {
    return audienceMatches(article.audiences, viewerPersona) && featureFlagSatisfied(article, featureFlags);
}
